export enum EventEmitterType {
  RelatedObjectsReload,
  RelatedObjectOpen,
  ObjectVersionsReload,
  ObjectDrawerOpen,
}
